{
  "commonHeader": {
    "toggleSidebar": "Afficher ou masquer la barre latérale",
    "cartLoading": "Chargement du panier",
    "cart": "Panier",
    "aicForAdmin": {
      "ariaLabel": "IA pour les administrateurs"
    },
    "usersResults": "Utilisateurs, {0} résultats",
    "settingsResults": "Paramètres, {0} résultats",
    "navigationResults": "Navigation, {0} résultats",
    "learnMoreAbout": "En savoir plus sur {0}",
    "close": "Fermer",
    "products": "Produits",
    "moreActions": "Autres actions",
    "search": "Rechercher",
    "searchPlaceholderAll": "Rechercher des utilisateurs, des paramètres de compte ou la navigation",
    "searchPlaceholderUsers": "Rechercher des utilisateurs ou la navigation",
    "searchPlaceholderSettings": "Rechercher des paramètres de compte ou la navigation",
    "searchPlaceholderNav": "Rechercher dans la navigation"
  },
  "footerCopyright": {
    "language": "Langue {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menu administrateur"
    }
  },
  "shared": {
    "close": "Fermer",
    "sideMenu": {
      "personalAria": "Menu personnel",
      "adminAria": "Menu administrateur",
      "mainNav": "Navigation principale",
      "submenu": "Sous-menu",
      "pinnedSection": "{0} épinglé",
      "sideMenuAria": "Menu latéral",
      "pinItem": "Épingler {0}",
      "unpinItem": "Désépingler {0}",
      "reorderGrabbed": "Réorganiser {0}, saisi. Utilisez les flèches haut et bas pour déplacer, Espace ou Entrée pour déposer, Échap pour annuler.",
      "reorderIdle": "Réorganiser {0}. Appuyez sur Espace ou Entrée pour saisir.",
      "hintHandlePin": "Appuyez sur Tab pour accéder à la poignée de déplacement et au bouton d’épinglage",
      "hintHandle": "Appuyez sur Tab pour accéder à la poignée de déplacement",
      "hintPin": "Appuyez sur Tab pour accéder au bouton d’épinglage",
      "upgradeToPro": "Passer à Pro"
    },
    "item": "Élément"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Essayer la nouvelle expérience"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Fermer"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Les divisions sont désormais disponibles"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Gérer les comptes externes"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Le carnet d’adresses deviendra le répertoire clients"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Zone produit",
    "itemLableForFeedback": "Commentaires"
  }
}
